import axiosClient from "./axiosClient";

const sanitizeFme1Payload = (form) => {
  const payload = { ...(form || {}) };
  delete payload.signature_image_data_url;
  return payload;
};

export const getInitialFME1Data = async (unitId) => {
  const res = await axiosClient.get(`/units/${unitId}/fme1/initial/`);
  return res.data?.data || {};
};

export const getFME1CheckboxSchema = async () => {
  const res = await axiosClient.get("/fme1/checkbox-schema/");
  return res.data?.checkboxes || [];
};

export const getFME1FormFieldSchema = async () => {
  const res = await axiosClient.get("/fme1/form-field-schema/");
  return res.data?.fields || [];
};

export const createFME1 = (unitId) => axiosClient.post(`/units/${unitId}/fme1/`);

export const getFME1ById = async (fme1Id) => {
  const res = await axiosClient.get(`/fme1/${fme1Id}/`);
  return {
    formData: res.data?.data || {},
    unitId: res.data?.unit_id,
    unitName: res.data?.unit_name,
    unitCode: res.data?.unit_code,
    propertyId: res.data?.property_id,
    propertyName: res.data?.property_name,
    status: res.data?.status,
    requestedDate: res.data?.requested_date,
    dueByDate: res.data?.due_by_date,
    createdAtUtc: res.data?.created_at_utc,
    updatedAtUtc: res.data?.updated_at_utc,
    rowVersion: res.data?.row_version,
  };
};

export const saveFME1 = (fme1Id, form, rowVersion) =>
  axiosClient.post(`/fme1/${fme1Id}/save/`, {
    ...sanitizeFme1Payload(form),
    row_version: rowVersion,
  });

export const updateFME1Meta = (fme1Id, payload, rowVersion) =>
  axiosClient.post(`/fme1/${fme1Id}/meta/`, { ...payload, row_version: rowVersion });

export async function downloadEditableFme1Pdf(fme1Id, payload = {}) {
  const response = await axiosClient.post(`/fme1/${fme1Id}/pdf-editable/`, payload, {
    responseType: "blob",
  });

  const blob = new Blob([response.data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  const disposition = response.headers?.["content-disposition"] || "";
  const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
  const filename = match ? decodeURIComponent(match[1]) : `FME1-${fme1Id}.pdf`;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export const getFME1ListForUnit = async (unitId) => {
  const res = await axiosClient.get(`/units/${unitId}/fme1/list/`);
  return res.data;
};

export const deleteFME1 = (fme1Id) => axiosClient.delete(`/fme1/${fme1Id}/delete/`);